import { render, staticRenderFns } from "./index.vue?vue&type=template&id=06974d7e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=06974d7e&prod&lang=scss&rel=stylesheet%2Fscss&media=print&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&id=06974d7e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06974d7e",
  null
  
)

export default component.exports